import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';

import { AgreementRecord } from '../entities/records';
import * as selectors from '../entities/Agreement/selectors';

function mapStateToProps(state, { agreementsIds }) {
  return {
    agreements: selectors.agreementsByIds(state, agreementsIds),
  };
}

export default compose(
  setPropTypes({
    agreementsIds: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  connect,
  setPropTypes({
    agreements: PropTypes.arrayOf(PropTypes.instanceOf(AgreementRecord)),
  }),
)(mapStateToProps);
